import React, { useState } from "react";
import "./IntroPage.css";
import { Link } from "react-router-dom";
import Loyalty from "../../assets/Loyalty.png";
import Online from "../../assets/online.png";
import Chatbot from "../../assets/Chatbot.png";
import Nurse from "../../assets/Nurse.png";
import Physiotherapy from "../../assets/Physiotherapy.png";
import DoctorHomeConsultation from "../../assets/Consultation.png";
import AISmartSummarization from "../../assets/AISmartSummarization.png";
import PhysiotherapyImagingLab from "../../assets/PhysiotherapyImagingLab.png";

const slides = [
  {
    title: "Loyalty Program",
    subtitle:
      "Earn loyalty points on every consultation & prescription to boost your profile and rewards.",
    img: Loyalty,
  },
  {
    title: "Online Consultation (In-App Call/Video)",
    subtitle:
      "Instantly book video or call consultations with trusted doctors, chat, share reports, and receive prescriptions—all in one place.",
    img: Online,
  },
  {
    title: "Home Doctor Consultation",
    subtitle: "Expert Care at Your Doorstep, schedule a doctor's visit to your home",
    img: DoctorHomeConsultation,
  },
  {
    title: "Nurse Service",
    subtitle: "Your Personal Nurse on Call, professional medical procedures at home",
    img: Nurse,
  },
  {
    title: "Physiotherapy/Imaging/Lab Center",
    subtitle: "Book physiotherapy, imaging, or lab services easily — our healthcare experts come to your home at your call.",
    img: PhysiotherapyImagingLab,
  },
  {
    title: "AI System – Virtual Medical Assistant (Chatbot)",
    subtitle:
      "Get instant answers to general medical queries about medicines and side effects.",
    img: Chatbot,
  },
  {
    title: "Smart Visit Doctor Consultation Summarization",
    subtitle:
      "AI automatically organizes consultation notes into clear patient records.",
    img: AISmartSummarization,
  },
];

const Introduction = ({ fromPage }) => {
  const [current, setCurrent] = useState(0);
  return (
    <div className="page-container">
      {/* Modal Section */}
      <div className="modal-overlay">
        <div className="modal-card">
          {
            <>
              <h2 className="modal-title">{slides[current].title}</h2>
              <p className="modal-subtitle">{slides[current].subtitle}</p>

              <div className="modal-illustration">
                <img src={slides[current].img} alt="slide" />
              </div>
            </>
            // )
          }

          {
            // !fromPage &&
            (
              <div className="modal-dots">
                {slides.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index === current ? "active" : ""}`}
                    onClick={() => setCurrent(index)}
                  ></span>
                ))}
              </div>
            )}

          <div className="modal-actions">
            {current < slides.length - 1 ? (
              <button
                className="modal-btn"
                onClick={() => setCurrent(current + 1)}
              >
                Next
              </button>
            ) : (
              // Show Add button only on the last slide (AI Summarization) based on selected role
              slides[current].title === "Smart Visit Doctor Consultation Summarization" ? (
                fromPage && (
                  <div className="d-flex align-items-center gap-2 justify-content-center">
                    {fromPage === "doctor" ? (
                      <Link to="/doctor-form" className="modal-btn">
                        Add New Doctor
                      </Link>
                    ) : fromPage === "doctor-home-consultation" ? (
                      <Link to="/doctor-home-consultation-form" className="modal-btn">
                        Add Doctor Home Consultation
                      </Link>
                    ) : fromPage === "nurse" ? (
                      <Link to="/nurse-form" className="modal-btn">
                        Add Nurse
                      </Link>
                    ) : fromPage === "physiotherapy" ? (
                      <Link to="/physiotherapy-form" className="modal-btn">
                        Add New Physiotherapy/Imaging/Lab Center
                      </Link>
                    ) : fromPage === "pharmacy" ? (
                      <Link to="/pharmacy-form" className="modal-btn">
                        Add New Pharmacy
                      </Link>
                    ) : null}
                  </div>
                )
              ) : (
                <button
                  className="modal-btn"
                  onClick={() => setCurrent(current + 1)}
                >
                  Next
                </button>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
